import React, { useEffect, useState } from 'react';
import './style.less';
import { SpotlightToggleCard } from '../ToggleCard';
import { SpotlightAccount } from 'types/spotlight';
import { Icon } from 'shared/components/Icon';
import Skeleton from 'react-loading-skeleton';
import { LBBContact } from 'sb-lib/types';
import { Segment } from 'types/segment';
import { getSpotlightContact } from 'shared/api';

export const SpotlightSegments: React.FC<{
  account?: SpotlightAccount | null;
  contact?: LBBContact | null;
  loading?: boolean;
}> = ({ account, contact, loading }) => {
  const [contactLoading, setContactLoading] = useState(false);
  const [segments, setSegments] = useState<Segment[]>([]);

  useEffect(() => {
    if (!account && !contact) setSegments([]);

    if (account) {
      setSegments(account?.segments ?? []);
    }

    if (contact) {
      setContactLoading(true);
      getSpotlightContact(contact.id).then(({ data }) => {
        setSegments(data?.segments ?? []);
        setContactLoading(false);
      });
    }
  }, [account, contact]);

  return (
    <>
      <SpotlightToggleCard
        title={
          <>
            <Icon icon="tagAlternate" /> Segments
          </>
        }
      >
        <div className="SpotlightSegments">
          {!loading && !contactLoading && !segments?.length && (
            <div className="SpotlightSegments__empty">No segments</div>
          )}
          {(!loading || contactLoading ? segments : [...new Array(5)])?.map((s, i) => {
            if (loading) {
              return (
                <Skeleton
                  baseColor="#F6F7F9"
                  width={100 * (i / 10) + 60}
                  height={24}
                  style={{ borderRadius: '6px' }}
                  key={`item-${i}`}
                />
              );
            }

            return (
              <div className="SpotlightSegments__item" key={`item-${i}`}>
                {s.name}
              </div>
            );
          })}
        </div>
      </SpotlightToggleCard>
    </>
  );
};
